<ng-container *ngIf="action$ | async"></ng-container>

<div class="flex flex-col h-full w-full">
  <div class="overflow-auto">
    <table mat-table class="w-full" *ngIf="data$ | async as data" [dataSource]="data">
      <!-- Select Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            [checked]="selection.isSelected(row)"
            (change)="selection.toggle(row)"
            [disabled]="row.quantityInStock < 0 && showQuantityInStock">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Texture Column -->
      <ng-container matColumnDef="texture">
        <th mat-header-cell *matHeaderCellDef i18n>Текстура</th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="!row.textureName && row.color; then showColor; else showTexture"> </ng-container>
          <ng-template #showColor>
            <div class="mw-texture mw-color" [ngStyle]="{ 'background-color': '#' + row.color }"></div>
          </ng-template>
          <ng-template #showTexture>
            <img
              (click)="openTextureViewerDialog(row.textureLink)"
              *ngIf="row.textureName !== ''"
              class="mw-texture"
              src="{{ row.cropTextureLink }}" />
          </ng-template>
        </td>
      </ng-container>

      <!-- Butt Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef i18n>Наименование</th>
        <td mat-cell *matCellDef="let row">
          <p #buttName class="h6">{{ row.name }}</p>
        </td>
      </ng-container>

      <!-- Article Column -->
      <ng-container matColumnDef="article">
        <th mat-header-cell *matHeaderCellDef i18n>Артикул</th>
        <td mat-cell *matCellDef="let row">
          <p #buttArticle class="h6">{{ row.article }}</p>
        </td>
      </ng-container>

      <!-- Thickness Column -->
      <ng-container matColumnDef="thickness">
        <th mat-header-cell *matHeaderCellDef i18n>Толщина (мм)</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.thickness }}</p>
        </td>
      </ng-container>

      <!--Quantity Material Stock Column-->
      <ng-container matColumnDef="quantityInStock">
        <th mat-header-cell *matHeaderCellDef i18n>Наличие на складе</th>
        <td *matCellDef="let row">
          <p *ngIf="row.quantityInStock > 0">{{ row.quantityInStock }} {{ row.measureName }}</p>
          <p i18n *ngIf="row.quantityInStock === 0">Под заказ</p>
          <p i18n *ngIf="row.quantityInStock === -1">Нет в наличии</p>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <div class="flex flex-col my-4 items-center">
    <button i18n mat-raised-button color="accent" (click)="chooseButtFormMatBase()">Выбрать из базы материалов</button>
  </div>
</div>
